import { useMutation } from '@tanstack/react-query'

import { generateVariants } from '..'

const useGenerateVariantsMutation = () => {
  return useMutation({ mutationFn: generateVariants })
}

export default useGenerateVariantsMutation
